module.exports = __webpack_public_path__ + "src/assets/img/hireco-logo.e6a808f8.svg";